module.exports = __webpack_public_path__ + "assets/media/lunch.80777e51.mp3";